// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Loader_overlay__TJ5q8"};